import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Service } from "@angular/core";
import * as localForage from "localforage";

import { environment } from "../environments/environment";
import { AdaaHelper, LocalForageStorage } from "../utils";

@Service()
export class MainInterceptorService {
  public interceptorMapFn(event: HttpEvent<unknown>) {
    if (event.type !== HttpEventType.Response) return event;

    if (!AdaaHelper.isLoggedIn()) return event;

    const urlStr = event.url?.replace(environment.apiUrl, "") ?? "";

    LocalForageStorage.STORED_APIS.forEach((api) => {
      if (new RegExp(api).test(urlStr)) {
        localForage
          .setItem(`${urlStr}`, event.body)
          .then(() => {})
          .catch(() => {});
      }
    });

    return event;
  }
}
